import * as yup from 'yup';
import { translate } from 'i18n/jhipster-language';
import { FIELD_CONSTRAINTS } from './field-constraints';
const { TEXT_MIN, TEXT_MAX, DESCRIPTION_MAX, NUMBER_MIN } = FIELD_CONSTRAINTS;
const requiredMsg = () => translate('entity.validation.required');
const minLenMsg = (min) => translate('entity.validation.minlength', { min });
const maxLenMsg = (max) => translate('entity.validation.maxlength', { max });
const minNumMsg = (min) => translate('entity.validation.min', { min });
const dateRangeMsg = () => translate('entity.validation.dateRange');
const trimValue = (value) => (typeof value === 'string' ? value.trim() : value);
const optionalLengthTest = (min, max) => ({
    name: 'optional-length',
    message: minLenMsg(min),
    test(value) {
        if (value == null || (typeof value === 'string' && value.trim() === '')) {
            return true;
        }
        const t = String(value).trim();
        if (t.length < min) {
            return this.createError({ message: minLenMsg(min) });
        }
        if (t.length > max) {
            return this.createError({ message: maxLenMsg(max) });
        }
        return true;
    },
});
/** Required user-entered text: 5–70 characters. */
export const requiredTextField = () => yup
    .string()
    .transform(trimValue)
    .required(requiredMsg())
    .min(TEXT_MIN, minLenMsg(TEXT_MIN))
    .max(TEXT_MAX, maxLenMsg(TEXT_MAX));
/** Optional text: empty OK; if set, 5–70 characters. */
export const optionalTextField = () => yup
    .string()
    .transform(trimValue)
    .nullable()
    .test(optionalLengthTest(TEXT_MIN, TEXT_MAX));
/** Required short code (e.g. currency): max 70, no minimum. */
export const requiredShortCodeField = () => yup
    .string()
    .transform(trimValue)
    .required(requiredMsg())
    .max(TEXT_MAX, maxLenMsg(TEXT_MAX));
/** Read-only / system-populated text: max 70 only. */
export const readOnlyTextField = () => yup
    .string()
    .nullable()
    .max(TEXT_MAX, maxLenMsg(TEXT_MAX));
/** Required description / notes: 5–700 characters. */
export const requiredDescriptionField = () => yup
    .string()
    .transform(trimValue)
    .required(requiredMsg())
    .min(TEXT_MIN, minLenMsg(TEXT_MIN))
    .max(DESCRIPTION_MAX, maxLenMsg(DESCRIPTION_MAX));
/** Optional description / notes: empty OK; if set, 5–700 characters. */
export const optionalDescriptionField = () => yup
    .string()
    .transform(trimValue)
    .nullable()
    .test(optionalLengthTest(TEXT_MIN, DESCRIPTION_MAX));
/** Non-negative number; required by default. */
export const nonNegativeNumberField = (required = true) => {
    let schema = yup
        .number()
        .typeError(translate('entity.validation.number'))
        .min(NUMBER_MIN, minNumMsg(NUMBER_MIN));
    if (required) {
        schema = schema.required(requiredMsg());
    }
    return schema;
};
/** Yup test: ISO date string `from` must not be after `until`. */
export const dateRangeFieldTest = (fromKey, untilKey) => ({
    name: 'date-range',
    message: dateRangeMsg(),
    test(_value, ctx) {
        const from = ctx.parent[fromKey];
        const until = ctx.parent[untilKey];
        if (!from?.trim() || !until?.trim()) {
            return true;
        }
        const fromDate = new Date(from);
        const untilDate = new Date(until);
        if (Number.isNaN(fromDate.getTime()) || Number.isNaN(untilDate.getTime())) {
            return true;
        }
        return fromDate.getTime() <= untilDate.getTime();
    },
});
